import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { uiKit1Components, uiKit2Components as uiKitLegacyComponents } from './defaultComponents';
import { Root, Fragment } from '../components/UIKit/internalComponents';
import { RendererNext } from './RendererNextComponent';
import { importMapMemo } from '../components/UIKit/importMap';
import { importMapChartsMemo } from '../components/UIKit-charts/importMapCharts';
import { ThreeLOPromptRenderFn } from '../components/threeLOPrompt/threeLOPrompt';
import { ComponentError } from '../error-boundary/ComponentErrorBoundary';
export var validComponentsHardcoded = new Set(['Badge', 'Banner', 'Bleed', 'Box', 'Button', 'ButtonGroup', 'Calendar', 'Checkbox', 'CheckboxGroup', 'Code', 'CodeBlock', 'DatePicker', 'DynamicTable', 'EmptyState', 'ErrorMessage', 'Flex', 'Form', 'FormFooter', 'FormHeader', 'FormSection', 'Grid', 'Heading', 'HelperMessage', 'Icon', 'Inline', 'InlineEdit', 'Label', 'LinkButton', 'List', 'ListItem', 'LoadingButton', 'Lozenge', 'Modal', 'ModalBody', 'ModalFooter', 'ModalHeader', 'ModalTitle', 'ModalTransition', 'Popup', 'ProgressBar', 'ProgressTracker', 'Radio', 'RadioGroup', 'Range', 'RequiredAsterisk', 'SectionMessage', 'SectionMessageAction', 'Select', 'Spinner', 'Stack', 'Tab', 'TabList', 'TabPanel', 'Tabs', 'Tag', 'TagGroup', 'TextArea', 'Textfield', 'TimePicker', 'Toggle', 'Tooltip', 'ValidMessage', 'BarChart', 'StackBarChart', 'HorizontalStackBarChart', 'HorizontalBarChart', 'LineChart', 'SingleValueChart', 'PieChart', 'String', 'Text', 'Image', 'Link', 'Em', 'Strong', 'Strike', 'Root', 'Fragment', 'ThreeLOPrompt', 'User', 'UserGroup', 'UserPicker', 'Frame', 'ContentWrapper', 'ValidationMessage', 'ButtonSet', 'DateLozenge', 'ErrorPanel', 'FormCondition', 'InlineDialog', 'ModalDialog', 'StatusLozenge', 'Table', 'TextField', 'View', 'TableRoot', 'TableCaption', 'TableHead', 'TableBody', 'TableFoot', 'TableRow', 'TableHeadCell', 'TableCell']);
var rendererNextComponents = {
  ThreeLOPrompt: ThreeLOPromptRenderFn
};

// This was extracted from RendererNext Component due to UnknownComponent Error being
// incompatible with running in a server-side context.
var customRenderErrorFn = function customRenderErrorFn(forgeDocType) {
  // Buckets errors into two kinds, ComponentError - component errors we want to report on e.g. <Button/> vs ones we don't e.g. <Buton/> which will only show up in the users console
  if (validComponentsHardcoded.has(forgeDocType)) {
    throw new ComponentError("Error rendering app - component ".concat(forgeDocType, "."), forgeDocType);
  } else {
    throw new Error("Error rendering app - encountered unknown component ".concat(forgeDocType, "."));
  }
};
export var RendererNextLatest = function RendererNextLatest(props) {
  var uiKitComponents = Object.keys(importMapMemo).reduce(function (acc, key) {
    var Component = importMapMemo[key];
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, function (args) {
      return /*#__PURE__*/React.createElement(Component, _extends({}, args, {
        key: args.forgeDoc.key
      }));
    }));
  }, {});
  var uiKitChartsComponents = Object.keys(importMapChartsMemo).reduce(function (acc, key) {
    var Component = importMapChartsMemo[key];
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, function (args) {
      return /*#__PURE__*/React.createElement(Component, _extends({}, args, {
        key: args.forgeDoc.key
      }));
    }));
  }, {});
  var components = _objectSpread(_objectSpread(_objectSpread({}, uiKitComponents), uiKitChartsComponents), {}, {
    String: uiKit1Components.String,
    Text: uiKitLegacyComponents.Text,
    Image: uiKitLegacyComponents.Image,
    Link: uiKitLegacyComponents.Link,
    Em: uiKit1Components.Em,
    Strong: uiKit1Components.Strong,
    Strike: uiKit1Components.Strike,
    Root: Root,
    Fragment: Fragment
  });
  var combinedComponents = _objectSpread(_objectSpread({}, components), rendererNextComponents);
  return /*#__PURE__*/React.createElement(RendererNext, _extends({}, props, {
    components: props.components ? props.components(combinedComponents) : combinedComponents,
    customRenderErrorFn: customRenderErrorFn
  }));
};
export var RendererNextLegacy = function RendererNextLegacy(props) {
  var components = props.isNative ? _objectSpread(_objectSpread({}, uiKit1Components), uiKitLegacyComponents) : uiKit1Components;
  var combinedComponents = _objectSpread(_objectSpread({}, components), rendererNextComponents);
  return /*#__PURE__*/React.createElement(RendererNext, _extends({}, props, {
    components: props.components ? props.components(combinedComponents) : combinedComponents,
    customRenderErrorFn: customRenderErrorFn
  }));
};